import React from "react";
import "./animatedLine.css"; // Import custom CSS for animation

const AnimatedGradientLine = () => {
  return (
    <div className="w-full my-2 h-[2px] bg-gradient-to-r from-green-300 to-green-900 animated-gradient-line"></div>
  );
};

export default AnimatedGradientLine;
